module.exports = __webpack_public_path__ + "static/media/shield-icon.b1afe907.svg";